/*
 * This file is part of glowingblue/orell-facade.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Component from 'flarum/common/Component';
import AbstractResponsiveComponent from './AbstractResponsiveComponent';

class DisruptorContent extends Component {
	view() {
		return (
			<div className={this.attrs.className}>
				<div className="Disruptor-textWrapper">
					<div className="Disruptor-circle" />
					<div className="Disruptor-text">{m.trust(this.attrs.deviceData)}</div>
				</div>
			</div>
		);
	}
}

export default class Disruptor extends AbstractResponsiveComponent {
	get data() {
		return this.attrs.banner.content()?.disruptor;
	}

	getClassName() {
		return `${super.className} Disruptor`;
	}

	get content() {
		return DisruptorContent;
	}
}
